import styled from "styled-components";
import {Modal} from "antd";

// Ekran görüntüsündeki tasarım: yuvarlatılmış köşeler, periwinkle mavi border
// ve mor primary buton. className, antd tarafından .ant-modal köküne uygulanır.
export const StyledModal = styled(Modal)`
    .ant-modal-content {
        border-radius: 16px;
        overflow: hidden;
    }

    .ant-modal-header {
        border-top-left-radius: 14px;
        border-top-right-radius: 14px;
        border-bottom: none;
    }

    .ant-modal-title {
        font-weight: 700;
    }

    .ant-modal-footer {
        border-top: none;
    }

    .ant-select .ant-select-selector {
        border-radius: 10px;
    }

    .ant-upload .ant-btn,
    .ant-modal-footer .ant-btn {
        border-radius: 10px;
    }
`;

export const NoteBox = styled.div`
    margin-top: 16px;
    padding: 16px;
    background-color: #f5f6f8;
    border-radius: 12px;

    p {
        margin: 0;
        font-size: 12px;
        color: #666;
    }
`;
